var fakeData = [
  {
    id: 1,
    location: "cox's bazar",
    title: "COX'S BAZAR",
    description: "Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach,tourism centre and district headquarters in southeastern Bangladesh.",
    subPlace: [
      {
        id: 3,
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        offer: "Cancellation fexibility availiable",
        condition: "Wif Air conditioning Kitchen",
        price: "$34/night",
        title: "Light bright airy stylish apt & safe peaceful stay",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/fvyPb93/Rectangle-26.png",
      },
      {
        id: 4,
        condition: "Wif Air conditioning Kitchen",
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        title: "Apartment in Lost Panorama",
        price: "$48/day",
        offer: "Cancellation fexibility availiable",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/b5dZ6jb/Rectangle-27.png"
      },
      {
        id: 5,
        condition: "Wif Air conditioning Kitchen",
        offer: "Cancellation fexibility availiable",
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        price: "$52/night",
        title: "AR Lounge & Pool (r&r + b&b)",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/RyNDRFv/Rectangle-28.png"
      }
    ]
  },
  {
    id: 2,
    location: "sreemongol",
    title: "SREEMONGOL",
    description: "Sreemangal is known as the tea capital of Bangladesh. It covers an overall are of 450 sq. km. The opulent green tea plantation attracts most tourists.It is famous mostly for its long natural sandy beach,tourism centre and district headquarters.",
    subPlace: [
     
      {
        id: 6,
        condition: "Wif Air conditioning Kitchen",
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        title: "Apartment in Lost Panorama",
        price: "$48/day",
        offer: "Cancellation fexibility availiable",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/KzzjgPg/215570818.jpg"
      },
      {
        id: 7,
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        offer: "Cancellation fexibility availiable",
        condition: "Wif Air conditioning Kitchen",
        price: "$34/night",
        title: "Light bright airy stylish apt & safe peaceful stay",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/BPwNZyN/anjali-travels-hotels.jpg",
      },
      {
        id: 8,
        condition: "Wif Air conditioning Kitchen",
        offer: "Cancellation fexibility availiable",
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        price: "$52/night",
        title: "AR Lounge & Pool (r&r + b&b)",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/HNQNYBT/download.jpg"
      },
    ]
  },
  {
    id: 3,
    location: "sundarban",
    title: "SUNDARBAN",
    description: "The Sundarbans mangrove forest, one of the largest such forests in the world (140,000 ha), lies on the delta of the Ganges, Brahmaputra and Meghna rivers on the Bay of Bengal.It is famous mostly for its long natural sandy beach.",
    subPlace: [
      {
        id: 9,
        condition: "Wif Air conditioning Kitchen",
        offer: "Cancellation fexibility availiable",
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        price: "$52/night",
        title: "AR Lounge & Pool (r&r + b&b)",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/mGgt0fR/Sundarban-Package-Bed-Room.jpg"
      },
      {
        id: 10,
        condition: "Wif Air conditioning Kitchen",
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        title: "Apartment in Lost Panorama",
        price: "$48/day",
        offer: "Cancellation fexibility availiable",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/yQbg6ZY/Sunderban-Mangrove-Retreat.png"
      },
      {
        id: 11,
        service: "4 guests 2 bedrooms 2 beds 2 baths",
        offer: "Cancellation fexibility availiable",
        condition: "Wif Air conditioning Kitchen",
        price: "$34/night",
        title: "Light bright airy stylish apt & safe peaceful stay",
        star: "https://i.ibb.co/zXmtZgL/star-1.png",
        image: "https://i.ibb.co/ckhSbGG/sunderban-tiger-camp3.jpg",
      },
      
    ]
  }
]

export default fakeData;